import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, ModelSignal, model } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { PricingPackage, PricingPackagesService } from "../_services/pricing-packages.service";
import { MatDialog } from "@angular/material/dialog";
import { PricingPackageEditDialogComponent } from "./pricing-package-edit-dialog/pricing-package-edit-dialog.component";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-pricing-packages",
    templateUrl: "./pricing-packages.component.html",
    styleUrls: ["./pricing-packages.component.scss"],
    standalone: false,
})
export class PricingPackagesComponent implements OnInit, OnDestroy {
    private ngUnsubscribe = new Subject<any>();
    readonly pricingPackages: ModelSignal<PricingPackage[]> = model<PricingPackage[]>([]);

    readonly displayedColumns: string[] = ["name", "type", "isHidden", "actions", "idx"];

    constructor(
        private pricingPackagesService: PricingPackagesService,
        private dialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.pricingPackagesService
            .list()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((packages) => {
                this.pricingPackages.set(packages);
            });
    }

    ngOnDestroy(): void {
        // prevent memory leak when component destroyed
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }

    createPackage(): void {
        const dialogRef = this.dialog.open(PricingPackageEditDialogComponent, { data: { packageId: "new" } });
        dialogRef.afterClosed().subscribe((result) => {
            if (!result) {
                return;
            }
            this.pricingPackages.set([...this.pricingPackages(), result]);
        });
    }

    edit(id: string): void {
        const dialogRef = this.dialog.open(PricingPackageEditDialogComponent, { data: { packageId: id } });
        dialogRef.afterClosed().subscribe((result) => {
            if (!result) {
                return;
            }
            const packages = this.pricingPackages();
            const index = packages.findIndex((pkg) => pkg.id === id);
            if (index !== -1) {
                packages[index] = result;
                this.pricingPackages.set([...packages]);
            }
        });
    }

    delete(id: string): void {
        this.pricingPackagesService
            .delete(id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
                const packages = this.pricingPackages();
                const index = packages.findIndex((pkg) => pkg.id === id);
                if (index !== -1) {
                    packages.splice(index, 1);
                    this.pricingPackages.set([...packages]);
                }
            });
    }
}
